import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-blue-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <img 
                src="https://public.readdy.ai/ai/img_res/d193d2b2-3175-4ede-ba3d-c2a0a6716122.png" 
                alt="Sustentare Logo" 
                className="h-10 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-blue-200 mb-6">
                Nossa missão é alimentar pessoas com produtos de qualidade, desenvolvidos com ingredientes selecionados e tecnologia avançada.
              </p>
            </div>
            
            {/* Social Links */}
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/sustentare.brasil" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a 
                href="https://www.instagram.com/sustentarealimentos" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
              >
                <i className="ri-instagram-fill text-lg"></i>
              </a>
              <a 
                href="https://www.youtube.com/user/tecnutrifoodservice" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-blue-800 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors"
              >
                <i className="ri-youtube-fill text-lg"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-blue-200 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/produtos" className="text-blue-200 hover:text-white transition-colors">
                  Empresa
                </Link>
              </li>
              <li>
                <Link to="/receitas" className="text-blue-200 hover:text-white transition-colors">
                  Pessoas & Cultura
                </Link>
              </li>
              <li>
                <Link to="/catalogos" className="text-blue-200 hover:text-white transition-colors">
                  Marcas
                </Link>
              </li>
              <li>
                <Link to="/noticias" className="text-blue-200 hover:text-white transition-colors">
                  Notícias
                </Link>
              </li>
            </ul>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Produtos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/produtos?categoria=bebidas" className="text-blue-200 hover:text-white transition-colors">
                  Bebidas Lácteas
                </Link>
              </li>
              <li>
                <Link to="/produtos?categoria=mingaus" className="text-blue-200 hover:text-white transition-colors">
                  Mingaus
                </Link>
              </li>
              <li>
                <Link to="/produtos?categoria=risotos" className="text-blue-200 hover:text-white transition-colors">
                  Risotos
                </Link>
              </li>
              <li>
                <Link to="/produtos?categoria=gelatinas" className="text-blue-200 hover:text-white transition-colors">
                  Gelatinas
                </Link>
              </li>
              <li>
                <Link to="/produtos?categoria=caldos" className="text-blue-200 hover:text-white transition-colors">
                  Caldos
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Contato</h3>
            <div className="space-y-4">
              <div className="flex items-start">
                <i className="ri-phone-line text-blue-300 mt-1 mr-3"></i>
                <div>
                  <p className="text-blue-200">Telefone</p>
                  <a href="tel:(19) 3852-8200" className="text-white hover:text-blue-200 transition-colors">
                    (19) 3852-8200
                  </a>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-mail-line text-blue-300 mt-1 mr-3"></i>
                <div>
                  <p className="text-blue-200">E-mail</p>
                  <a href="mailto:contato@sustentare.com.br" className="text-white hover:text-blue-200 transition-colors">
                    contato@sustentare.com.br
                  </a>
                </div>
              </div>
              
              <div className="flex items-start">
                <i className="ri-map-pin-line text-blue-300 mt-1 mr-3"></i>
                <div>
                  <p className="text-blue-200">Endereço</p>
                  <p className="text-white">
                    Est. Mun. Fioravante Carlotti nº 1901<br />
                    Bairro Santa Tereza<br />
                    13920-314, Pedreira - SP
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-blue-800">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-blue-200 text-sm mb-4 md:mb-0">
              © 2025 Sustentare. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-4">
              <a 
                href="https://wa.me/19995563309"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-200 hover:text-white text-sm transition-colors"
              >
                M.PLACIDINO
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
